import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  NEAR_BLACK,
  DARK_GRAY,
  GRAY,
  LIGHT_BLUE,
  LIGHT_GRAY,
  NEAR_WHITE,
} from "../../config/colors";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px ${NEAR_WHITE} solid;
  padding: 32px;
  padding-bottom: 20px;
  align-items: center;
  color: ${NEAR_WHITE};
`;

export const Title = styled.h2`
  display: flex;
  text-align: center;
  color: ${NEAR_WHITE};
  margin: 0px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CloseOption = styled.div`
  width: fit-content;
  height: fit-content;
  padding: inherit;
  float: right;
  padding: 0px;
`;

export const CloseModal = styled(FontAwesomeIcon)`
  display: flex;
  cursor: pointer;
  color: ${NEAR_WHITE};
  font-size: 16px;
  padding-left: 20rem;
`;

export const OptionsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 16px 15px;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 220px;
  height: 193px;
  padding: 10px;
`;

export const OptionImage = styled.img`
  width: 220px;
  height: 137px;
  background: ${GRAY};
`;

export const RadioButtonContainer = styled.div`
  height: 50px;
  background: ${GRAY};
  font-size: 16px;
  color: ${NEAR_WHITE};
  border: none;
  align-items: center;
  justify-content: space-around;
  display: flex;
  border-radius: 0px 0px 6px 6px;
`;

export const ButtonConfirm = styled.a`
  display: flex;
  align-items: center;
  outline: none;
  border-radius: 4px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s ease;
  white-space: nowrap;
  justify-content: center;
  font-family: Roboto;
  width: fit-content;
  background: ${LIGHT_BLUE};
  color: ${NEAR_WHITE};
  border: none;
  text-decoration: none;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 2.4rem;

  .disabled {
    pointer-events: none;
    background: ${DARK_GRAY};
    border: 1px solid ${LIGHT_GRAY};
    color: ${LIGHT_GRAY};
    border-radius: 5px;
  }
`;

export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: NEAR_BLACK,
    border: "none",
    borderRadius: "1rem",
    padding: "0",
    width: "760px",
    height: "393px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
    zIndex: 5,
  },
};
